import { FolderPlus } from "lucide-react-native";
import { FC, useState } from "react";
import { Platform, Pressable } from "react-native";

import { Box, HStack } from "@/components/ui";

interface AddSectionProps {
  disabled?: boolean;
  onPress: () => void;
}

/**
 * Inline "insert section here" affordance — same hover-reveal pattern as
 * `AddQuestion`, but with a folder icon to disambiguate the action.
 */
const AddSection: FC<AddSectionProps> = ({ disabled = false, onPress }) => {
  const [hovered, setHovered] = useState(false);
  const isWeb = Platform.OS === "web";
  const active = !disabled && hovered;

  return (
    <Pressable
      accessibilityRole="button"
      disabled={disabled}
      onHoverIn={isWeb ? () => setHovered(true) : undefined}
      onHoverOut={isWeb ? () => setHovered(false) : undefined}
      onPress={disabled ? undefined : onPress}
      style={{
        cursor: disabled ? "auto" : "pointer",
        paddingVertical: 6,
        width: "100%",
      }}
    >
      {active && (
        <HStack className="items-center gap-2">
          <Box className="h-px flex-1 bg-primary-400" />
          <FolderPlus color="rgb(var(--color-primary-500))" size={16} />
          <Box className="h-px flex-1 bg-primary-400" />
        </HStack>
      )}
    </Pressable>
  );
};

export default AddSection;
